import { FilterGroupName, LineTypes } from 'results/constants'
import type { Filters } from 'src/store/models/SearchModels'
import type { AppliedFilterChipDescriptor } from './types'

export const getAppliedFilterChips = (
  filters: Filters
): AppliedFilterChipDescriptor[] => {
  const chips: AppliedFilterChipDescriptor[] = []

  filters.forEach((filter) => {
    if (filter.groupName === FilterGroupName.STOCK) {
      return
    }

    filter.items.forEach((item) => {
      if (
        filter.groupName === FilterGroupName.LINES &&
        item === LineTypes.ALL_LINES
      ) {
        return
      }

      chips.push({
        id: `${filter.groupName}:${item}`,
        label: item,
        kind: 'facet',
        groupName: filter.groupName,
        value: item,
      })
    })
  })

  return chips
}
